module.exports = __webpack_public_path__ + "static/media/worry-free-2.cfb0cd46.png";